// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@eisinc/MobiusOverrides/Button";
import { cartTotalStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

cartTotalStyles.container = {
    gap: 0,
    offsetCss: css`
        flex-direction: column;
        gap: 12px;
        border: 1px solid ${color("common.border")};
        padding-bottom: 12px;
    `,
};

cartTotalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        display: flex;
        padding: 0 12px;
        gap: 12px;
        > ${ButtonWrapper} {
            flex: 1;
        }
    `,
};
